import { useQuery } from "react-query";
import { getAllEmployers } from "services/employer.service";

export default function useEmployers(params?: { page?: number; limit?: number }) {
  return useQuery(["employers", params], () => getAllEmployers(params), {
    keepPreviousData: true,
  });
}
